export class LandUseType {
  landUseTypeID: number;
  name: string;
}
